<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('reports.list') }}</h1>
        </div>
      </div>
      <ul class="list"><!--
        <li><a class="has-text-primary" @click="goTo('userReport')">
          {{ $t('routes.userReport') }}
        </a></li>-->
        <li><a class="has-text-primary" @click="goTo('employeeExecutionReport')">
          {{ $t('routes.employeeExecutionReport') }}
        </a></li>
        <li><a class="has-text-primary" @click="goTo('employeesOverdueDocumentsByRegisterBooks')">
          {{ $t('routes.employeesOverdueDocumentsByRegisterBooks') }}
        </a></li>
        <li><a class="has-text-primary" @click="goTo('shortBySenders')">
          {{ $t('routes.shortBySenders') }}
        </a></li>
        <li><a class="has-text-primary" @click="goTo('expiringDocsByRegisterBooks')">
          {{ $t('routes.expiringDocsByRegisterBooks') }}
        </a></li>
        <template v-if="isReportsManager">
          <li><a class="has-text-primary" @click="goTo('appealsByCategoriesAndRegions')">
            {{ $t('routes.appealsByCategoriesAndRegions') }}
          </a></li>
          <li><a class="has-text-primary" @click="loadEmployeesDocsByState()">
            {{ $t('routes.employeesDocsByState') }}
          </a></li>
        </template>
      </ul>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {prepareDate, userDetail, objectToURLParams, outputFile} from '@/utils'
  import {mapGetters, mapState} from 'vuex'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {}
    },
    methods: {
      goTo(route) {
        this.$router.push({name: route})
      },
      loadEmployeesDocsByState() {
        this.$store.dispatch('Reports/employeesDocsByState', {export: true}).then(() => {
          outputFile('report.docx', this.exportData)
        })
      }
    },
    computed: {
      ...mapGetters('Reports', ['employeesDocsByState', 'exportData']),
      ...mapGetters('Account', ['isReportsManager']),
      ...mapState('Reports', ['exportData']),
      breadcrumbs() {
        return [
          {name: 'reportsList'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list {
    list-style: disc;
    box-shadow: none;

    li {
      margin-bottom: 4px;
    }
  }
</style>
